// Import and register all Stimulus controllers matched by the webpack context
import { application } from "./application"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const context = require.context("./", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
